export const computeToggleSelection = (
  selectedUsers: string[],
  id: string,
  terms: any[],
) => {
  let updatedSelectedUsers = [...selectedUsers];

  if (updatedSelectedUsers.includes(id)) {
    updatedSelectedUsers = updatedSelectedUsers.filter((userId) => userId !== id);
  } else {
    updatedSelectedUsers.push(id);
  }

  return {
    updatedSelectedUsers,
    selectAllChecked: updatedSelectedUsers.length === terms.length,
  };
};

export const computeSelectAll = (checked: boolean, terms: any[]) => {
  if (checked) {
    return { selectedUsers: terms.map((t) => t.uuid), selectAllChecked: true };
  }

  return { selectedUsers: [], selectAllChecked: false };
};

export const toggleSelect = (prevSelected: string[], uuid: string) =>
  prevSelected.includes(uuid) ? prevSelected.filter((id) => id !== uuid) : [...prevSelected, uuid];
